import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer"]

  connect() {
    // Initialize any drawer elements that should be closed by default
    this.drawerTargets.forEach(drawer => {
      if (!drawer.classList.contains("md:translate-x-0")) {
        drawer.classList.add("-translate-x-full")
      }
    })
  }

  toggle(event) {
    const targetId = event.currentTarget.getAttribute("data-drawer-target")
    const drawer = document.getElementById(targetId)
    
    if (!drawer) {
      return
    }
    
    // Toggle the drawer visibility
    drawer.classList.toggle("-translate-x-full")
    
    // Update aria-expanded for accessibility
    const isOpen = !drawer.classList.contains("-translate-x-full")
    event.currentTarget.setAttribute("aria-expanded", isOpen)
  }

  close(event) {
    // Close drawer when clicking outside (for mobile)
    if (window.innerWidth >= 768) return // Don't close on desktop
    
    const isClickInsideDrawer = event.target.closest("#drawer-navigation")
    const isClickOnToggleButton = event.target.closest("[data-drawer-toggle]")
    
    if (!isClickInsideDrawer && !isClickOnToggleButton) {
      this.drawerTargets.forEach(drawer => {
        if (!drawer.classList.contains("-translate-x-full")) {
          drawer.classList.add("-translate-x-full")
        }
      })
    }
  }

  // Called when the controller is added to the DOM
  initialize() {
    // Add click outside listener for mobile
    document.addEventListener("click", this.close.bind(this))
  }

  // Called when the controller is removed from the DOM
  disconnect() {
    document.removeEventListener("click", this.close.bind(this))
  }
}